module.exports = __webpack_public_path__ + "static/img_9890_dpp_optimized-f5ffd9c3a5333766ce4062beb59a1b16.jpg";